import React from 'react';

const SIZE_CLASSES = {
  sm: 'h-10 w-10',
  md: 'h-14 w-14',
  lg: 'h-20 w-20',
};

const Loader = ({
  label = 'Loading fresh picks...',
  sublabel = 'Please wait while we prepare the latest data.',
  fullScreen = false,
  compact = false,
  size = 'md',
  className = '',
}) => {
  const content = (
    <div className={`flex flex-col items-center justify-center text-center ${compact ? 'py-8' : 'py-16'} ${className}`}>
      <div className="relative">
        <div className={`${SIZE_CLASSES[size] || SIZE_CLASSES.md} rounded-full border-[6px] border-primary-100`} />
        <div className={`absolute inset-0 ${SIZE_CLASSES[size] || SIZE_CLASSES.md} animate-spin rounded-full border-[6px] border-transparent border-t-primary-600 border-r-emerald-400`} />
        <div className="absolute inset-3 rounded-full bg-white shadow-inner" />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="h-2.5 w-2.5 rounded-full bg-primary-600 shadow-lg shadow-primary-300" />
        </div>
      </div>

      {label && (
        <p className="mt-5 text-sm font-extrabold uppercase tracking-[0.18em] text-gray-800">
          {label}
        </p>
      )}
      {sublabel && (
        <p className="mt-2 max-w-sm text-sm leading-relaxed text-gray-500">
          {sublabel}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center bg-gray-50 px-4">
        <div className="w-full max-w-md rounded-3xl border border-gray-100 bg-white p-8 shadow-xl shadow-black/5">
          {content}
        </div>
      </div>
    );
  }

  return content;
};

export default Loader;
